import { Typography } from '@mui/material'
import React, { Fragment, memo, useCallback } from 'react'
import tw from 'twin.macro'
import { CircleRightMajor } from '@shopify/polaris-icons'
import BGCIcon from 'src/assets/icons/bgc.svg'
import { useSelector } from 'react-redux'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { useYardstik } from 'src/hooks/useYardstik'
import { BGCCollectDataStep } from 'src/interfaces/collectData'
import { Button } from '../shared/Button'
import { SecureWrapper } from '../layout/SecureWrapper'
import { StepLabels } from '../client/step-labels/StepLabels'

interface Props {
  onOpenManualUpload?: () => void
  onBack?: () => void
}

const BGCYardstikComponent = ({ onOpenManualUpload, onBack }: Props) => {
  const currentStep = useSelector(getCurrentCollectDataStep) as BGCCollectDataStep

  const { isYardstikLoading, startYardstik, YardstikView } = useYardstik()

  const showYardstik = useCallback(() => {
    startYardstik(currentStep.id)
  }, [currentStep.id])

  return (
    <Fragment>
      <SecureWrapper
        onBack={onBack}
        footer={
          <Button
            className={tw`w-full`}
            loading={isYardstikLoading}
            onClick={showYardstik}
            data-testid="contractors-onboarding-bgc-yardstik-proceed-btn"
          >
            Proceed with Yardstik
          </Button>
        }
      >
        <div
          css={tw`w-11 h-11 flex justify-center items-center [border-radius: 22px] bg-shades-100 mt-2 mb-4`}
        >
          <img src={BGCIcon} />
        </div>
        <StepLabels />
        <Typography css={tw`mb-2 mt-2`} variant="h2">
          Background Check & Motor Vehicle Record
        </Typography>
        <Typography css={tw`mb-4 text-shades-400`}>
          To conduct your Background Check & Motor Vehicle Record report we'll use our industry
          leading partner, Yardstik. Tap "Proceed with Yardstik" button below to begin.
        </Typography>
        {onOpenManualUpload ? (
          <div css={tw`rounded-2xl p-4 bg-shades-0 mt-6`}>
            <Typography css={tw`mb-1`} variant="h4">
              Already have Background Check & Motor Vehicle Report documents?
            </Typography>
            <Typography css={tw`mb-4 text-shades-400`}>
              Please upload your documents to expedite the process.
            </Typography>
            <Button
              leftIcon={<CircleRightMajor css={tw`fill-primary-500`} width={20} />}
              className={tw`w-full`}
              color="light"
              onClick={onOpenManualUpload}
              data-testid="contractors-onboarding-bgc-manual-upload-btn"
            >
              Tap to upload documents
            </Button>
          </div>
        ) : null}
      </SecureWrapper>
      <YardstikView />
    </Fragment>
  )
}

export const BGCYardstik = memo(BGCYardstikComponent)
